import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  Label processing Services
 * !== 라벨 처리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/lbl`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/sysm/lbl/lbl-lang`,
    nodes: [
        { path: "/", label: "L_LBL_MGMT" },
        { path: "/ptl/lbl", label: "L_LBL_MGMT" },
    ],
};

export const URLS = {
    osci0111004q: `${BASE.path}/osci0111004q`, // Label processing List !==  라벨 처리 목록 ==!
    osci0111005s: `${BASE.path}/osci0111005s`, // Label processing Registration !==  라벨 처리 등록 ==!
    osci0111006s: `${BASE.path}/osci0111006s`, // Modifying and deleting Label processing !==  라벨 처리 수정 및 삭제 ==!
};

export const APIS = {
    // Label processing List !==  라벨 처리 목록 ==!
    getLblLangList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Label processing information !==  라벨 처리 정보 조회 ==!
    getLblLang: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },

    // Label processing information save !==  라벨 처리 정보 저장  ==!
    saveLblLang: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Label processing information save !==  라벨 처리 정보 저장  ==!
    updateLblLang: (data: any) => {
        return api.post(`${BASE.api}/update`, {
            ...data,
        });
    },

    //Label processing information delete  !==  라벨 처리 정보 삭제 ==!
    deleteLblLang: (lblId: any) => {
        return api.delete(`${BASE.api}/${lblId}`);
    },
};

export const SF_LBL_LANG_SRCH: TFormSchema = {
    id: "form_LblLangSrch",
    schema: {
        lblId: { type: "text", label: "L_LBL_ID", letterCase: "upper" },
        lblNm: { type: "text", label: "L_LBL_NM" },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_CD", all: true, area: "comnCd", comnCd: "OSC0088" },
        lblTpCd: {
            type: "select",
            label: "L_LBL_TP_CD",
            options: [
                { label: "Label", value: "L" },
                { label: "Title", value: "T" },
                { label: "Button", value: "B" },
            ],
        },
    },
};

export const SF_LBL_LANG: TFormSchema = {
    id: "form_LblLang",
    schema: {
        lblId: {
            type: "text",
            label: "L_LBL_ID",
            letterCase: "upper",
            required: true,
            minLength: 3,
            maxLength: 30,
        },
        // Keep the language label limits aligned with OSCI_LBL_LANG_M.LBL_NM.
        lblNmKo: { type: "text", label: "L_LBL_NM_KOR", controlSize: 10, required: true, maxLength: 300 },
        lblNmEn: { type: "text", label: "L_LBL_NM_ENG", controlSize: 10, required: true, maxLength: 300 },
        lblNmTz: { type: "text", label: "L_LBL_NM_TZ", controlSize: 10, required: true, maxLength: 300 },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            required: true,
            all: true,
            area: "comnCd",
            comnCd: "OSC0088",
        },
        lblTpCd: {
            type: "select",
            label: "L_LBL_TP_CD",
            select: false,
            required: true,
            options: [
                { label: "Label", value: "L" },
                { label: "Title", value: "T" },
                { label: "Button", value: "B" },
            ],
        },
        frstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM" },
    },
};

export const SG_LBL_LANG_LIST: TGridSchema = {
    id: "grid_LblLangList",
    options: { pagination: "out", checkbox: true, index: true },
    head: [
        { cells: [{ header: "L_LBL_ID", binding: "lblId", width: "10%" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "10%" }] },
        { cells: [{ header: "L_LBL_TP_CD", binding: "lblTpCd", width: "10%" }] },
        { cells: [{ header: "L_LBL_NM_ENG", binding: "lblNmEn", width: "*" }] },
        { cells: [{ header: "L_LBL_NM_TZ", binding: "lblNmTz", width: "*" }] },
        { cells: [{ header: "L_LBL_NM_KOR", binding: "lblNmKo", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "lblId" }] },
        { cells: [{ binding: "bsopClsfCd" }] },
        { cells: [{ binding: "lblTpCd" }] },
        { cells: [{ binding: "lblNmEn", align: "left" }] },
        { cells: [{ binding: "lblNmTz", align: "left" }] },
        { cells: [{ binding: "lblNmKo", align: "left" }] },
        { cells: [{ binding: "frstRegstId" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

export {};
